module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "messageMode"
  }, [_c('div', {
    staticClass: "saveMessage"
  }, [_c('div', {
    staticClass: "icon-x",
    on: {
      "click": function($event) {
        return _vm.determine('on-close')
      }
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "btn-ok",
    on: {
      "click": function($event) {
        return _vm.determine('on-action')
      }
    }
  }, [_vm._v(_vm._s(_vm.action))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf3f454","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageConfirm.vue
// module id = 830
// module chunks = 0